(function () {
    "use strict";
    angular.module('skillBuilderSaaS')
        .controller("AddPathsModalCtrl", ["learningPathResource", "$scope", "$translate", "_", AddPathsModalCtrl]);
    function AddPathsModalCtrl(learningPathResource, $scope, $translate, _) {
        var vm = this;
        vm.availablePathsLoaded = false;
        vm.noMorePathsToAdd = false;
        vm.availablePaths = [{ name: $translate.instant("learningItems.manageCategoriesAndBands.addPathModal.loadingPathsToAdd"), id: 0 }];
        learningPathResource.getAvailablePaths(function (result) {
            if (result.length > 0) {
                vm.availablePaths = result;
                vm.availablePathsLoaded = true;
            }
            else {
                vm.availablePathsLoaded = false;
                vm.noMorePathsToAdd = true;
            }
        });
        vm.moveDown = function (selectedPaths) {
            vm.selectedPaths2 = _.union(vm.selectedPaths2, selectedPaths);
            vm.availablePaths = _.difference(vm.availablePaths, vm.selectedPaths2);
        };
        vm.moveUp = function (pathsToRemove) {
            vm.availablePaths = _.union(pathsToRemove, vm.availablePaths);
            vm.selectedPaths2 = _.difference(vm.selectedPaths2, pathsToRemove);
        };
        vm.save = function () {
            if (vm.selectedPaths2.length > 0)
                $scope.$close(vm.selectedPaths2);
            else
                $scope.$dismiss();
        };
    }
}());
